import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserCrmIds} from 'src/openapi/admin/models/UserCrmIds';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultCrmIdsSlice = getCachedTableDataSlice<
    Record<string, UserCrmIds>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultCrmIds');

export const userSearchResultCrmIdsActions = userSearchResultCrmIdsSlice.actions;

const userSearchResultCrmIdsCacheSelector: CachedTableCacheSelector<Record<string, UserCrmIds>>
    = state => state.userSearchResult.crmIds.cache;
export const userSearchResultCrmIdsDataSelector: CachedTableDataSelector<Record<string, UserCrmIds>>
    = state => state.userSearchResult.crmIds;
export const userSearchResultCrmIdsResultSelector = getCachedTableResultSelector(
    userSearchResultCrmIdsCacheSelector,
    userSearchResultStateSelector,
);
